/**
 * Portal Manta · RodoviaDecomp
 * Extraído de App.jsx v29.3 (via AST)
 */
import React, { useState, useEffect, useMemo, useCallback, Fragment, memo } from 'react';
import { V, S, FonteBadge } from '../../globals.js';
import { RODOVIAS_LOTE } from '../../data/rodovias-lote.js';
import { M } from '../../tokens/colors.js';

function RodoviaDecomp({lote, capExAmpl, onFonte}){
  const lk = lote.k;
  const rods = RODOVIAS_LOTE[lk] || [];
  // distribui CAPEX por (km × peso) e devolve linhas com R$/km
  const total_pond = rods.reduce((s,r)=>s+(r.km*r.peso),0)||1;
  const linhas = rods.map(r=>{
    const share = (r.km*r.peso)/total_pond;
    const cap = capExAmpl * share;            // R$ M
    const rsKm = r.km>0 ? cap/r.km : 0;       // R$ M/km
    const km_n = r.km - r.km_urb;
    const denom = km_n + r.km_urb*1.7;
    const rsKm_n = denom>0 ? cap/denom : 0;
    const rsKm_u = rsKm_n*1.7;
    const cap_u = rsKm_u * r.km_urb;
    return {...r, share, cap, rsKm, rsKm_n, rsKm_u, cap_u};
  });
  const fmt1 = (n)=>(n||0).toLocaleString('pt-BR',{minimumFractionDigits:1,maximumFractionDigits:1});
  const fmt0 = (n)=>(n||0).toLocaleString('pt-BR',{minimumFractionDigits:0,maximumFractionDigits:0});
  return (<div style={{...S.cardP, marginBottom:16, padding:'18px 20px'}}>
    <div style={{display:'flex',alignItems:'center',gap:8,marginBottom:6}}>
      <div style={{width:24,height:24,borderRadius:6,background:'#5D3A1A',color:'#fff',display:'flex',alignItems:'center',justifyContent:'center',fontSize:11,fontWeight:700}}>4</div>
      <div style={{fontSize:13,fontWeight:700,color:V.br}}>Decomposição por Rodovia — onde o CAPEX se concentra e por quê</div>
    </div>
    <div style={{fontSize:10.5,color:V.g5,marginBottom:12}}>CAPEX de ampliação distribuído por (km × peso de complexidade). Driver = razão técnica que empurra o custo. Premissa de R$/km urbano = 1,7× rural mantida.</div>

    <div style={{overflowX:'auto'}}>
      <table style={{width:'100%',borderCollapse:'collapse',fontSize:11}}>
        <thead><tr style={{background:V.g0,borderBottom:'2px solid '+V.g2}}>
          <th style={{padding:'8px 10px',textAlign:'left',fontWeight:700,color:V.g5,fontSize:10}}>Rodovia</th>
          <th style={{padding:'8px 10px',textAlign:'right',fontWeight:700,color:V.g5,fontSize:10}}>km total</th>
          <th style={{padding:'8px 10px',textAlign:'right',fontWeight:700,color:V.g5,fontSize:10}}>km urb</th>
          <th style={{padding:'8px 10px',textAlign:'right',fontWeight:700,color:V.g5,fontSize:10}}>% urb</th>
          <th style={{padding:'8px 10px',textAlign:'right',fontWeight:700,color:V.or,fontSize:10}}>CAPEX (R$ M)</th>
          <th style={{padding:'8px 10px',textAlign:'right',fontWeight:700,color:V.gn,fontSize:10}}>R$/km rural</th>
          <th style={{padding:'8px 10px',textAlign:'right',fontWeight:700,color:V.or,fontSize:10}}>R$/km urb</th>
          <th style={{padding:'8px 10px',textAlign:'right',fontWeight:700,color:V.bl,fontSize:10}}>CAPEX urb (R$ M)</th>
          <th style={{padding:'8px 10px',textAlign:'left',fontWeight:700,color:V.g5,fontSize:10}}>Driver principal</th>
          <th style={{padding:'8px 10px',textAlign:'center',fontWeight:700,color:V.g5,fontSize:10}}>📍</th>
        </tr></thead>
        <tbody>
          {linhas.map((r,i)=>{
            const pctU = r.km>0 ? (r.km_urb/r.km*100) : 0;
            return (<tr key={i} style={{borderBottom:'1px solid '+V.g1}}>
              <td style={{padding:'8px 10px',fontWeight:700,color:V.br}}>{r.rod}</td>
              <td style={{padding:'8px 10px',textAlign:'right',fontFamily:'monospace'}}>{fmt1(r.km)}</td>
              <td style={{padding:'8px 10px',textAlign:'right',fontFamily:'monospace',color:V.or}}>{fmt1(r.km_urb)}</td>
              <td style={{padding:'8px 10px',textAlign:'right',color:V.g5,fontSize:10}}>{pctU.toFixed(0)}%</td>
              <td style={{padding:'8px 10px',textAlign:'right',fontWeight:700,color:V.or,fontFamily:'monospace'}}>{fmt0(r.cap)}</td>
              <td style={{padding:'8px 10px',textAlign:'right',color:V.gn,fontFamily:'monospace'}}>{fmt1(r.rsKm_n)}</td>
              <td style={{padding:'8px 10px',textAlign:'right',color:V.or,fontFamily:'monospace',fontWeight:600}}>{fmt1(r.rsKm_u)}</td>
              <td style={{padding:'8px 10px',textAlign:'right',color:V.bl,fontFamily:'monospace'}}>{fmt0(r.cap_u)}</td>
              <td style={{padding:'8px 10px',color:V.g5,fontSize:10.5,maxWidth:280}}>{r.driver}</td>
              <td style={{padding:'8px 10px',textAlign:'center'}}><FonteBadge fonte={r.f} onClick={()=>onFonte({fonte:r.f,label:`${r.rod} — driver de custo`})}/></td>
            </tr>);
          })}
        </tbody>
        <tfoot>
          <tr style={{background:V.g0,borderTop:'2px solid '+V.g2,fontWeight:700}}>
            <td style={{padding:'8px 10px',color:V.br}}>Total</td>
            <td style={{padding:'8px 10px',textAlign:'right',fontFamily:'monospace'}}>{fmt1(linhas.reduce((s,r)=>s+r.km,0))}</td>
            <td style={{padding:'8px 10px',textAlign:'right',fontFamily:'monospace',color:V.or}}>{fmt1(linhas.reduce((s,r)=>s+r.km_urb,0))}</td>
            <td/>
            <td style={{padding:'8px 10px',textAlign:'right',color:V.or,fontFamily:'monospace'}}>{fmt0(linhas.reduce((s,r)=>s+r.cap,0))}</td>
            <td/><td/>
            <td style={{padding:'8px 10px',textAlign:'right',color:V.bl,fontFamily:'monospace'}}>{fmt0(linhas.reduce((s,r)=>s+r.cap_u,0))}</td>
            <td colSpan={2}/>
          </tr>
        </tfoot>
      </table>
    </div>

    <div style={{marginTop:12,padding:'10px 12px',background:V.orp,borderRadius:6,fontSize:10.5,color:V.br2,lineHeight:1.5}}>
      <strong>Como ler:</strong> R$/km urbano e rural por rodovia permitem identificar onde a obra "engorda" o orçamento — rodovias com 100% urbano (como PR-170) são caras de ponta a ponta; rodovias com pouco urbano (como BR-373) puxam a média para baixo. <strong>O share de CAPEX</strong> usa peso técnico além do km — Serra do Mar pesa mais que trecho plano de mesma extensão.
    </div>
  </div>);
}

export { RodoviaDecomp };
export default RodoviaDecomp;
